import { UserPermissions, UserInformation } from './permissions.manager.type'
import { Environment, Metadata, Plan } from '@workspaces/types'
import PermissionResolver from './resolvers/resolver'

class UserPermissionManager implements UserPermissions {
  private static instance: UserPermissions
  private permissionResolver: UserPermissions

  private constructor(userInformation: UserInformation) {
    this.permissionResolver = new PermissionResolver(userInformation)
  }

  public static initialize(userInformation: UserInformation): UserPermissions {
    UserPermissionManager.instance = new UserPermissionManager(userInformation)
    return UserPermissionManager.instance
  }

  public static getInstance(): UserPermissions {
    if (!UserPermissionManager.instance) {
      throw new Error(
        'UserPermissionManager is not initialized. Must be initialized before using it',
      )
    }

    return UserPermissionManager.instance
  }

  public canUploadCustomPOIs(): boolean {
    return this.permissionResolver.canUploadCustomPOIs()
  }

  public canEditAnyCustomPOIGroup(): boolean {
    return this.permissionResolver.canEditAnyCustomPOIGroup()
  }

  public canSavePlan(plan: Plan.Plan): boolean {
    return this.permissionResolver.canSavePlan(plan)
  }

  public canSharePlan(plan: Plan.Plan): boolean {
    return this.permissionResolver.canSharePlan(plan)
  }

  public canSavePlanAsPublic(): boolean {
    return this.permissionResolver.canSavePlanAsPublic()
  }

  public canDeletePlan(plan: Plan.Plan): boolean {
    return this.permissionResolver.canDeletePlan(plan)
  }

  public canDeleteCustomGeoboundary(owner: string): boolean {
    return this.permissionResolver.canDeleteCustomGeoboundary(owner)
  }

  public canDeleteCustomPOIGroup(owner: string): boolean {
    return this.permissionResolver.canDeleteCustomPOIGroup(owner)
  }

  public canUpdateCustomPOIGroup(owner: string): boolean {
    return this.permissionResolver.canUpdateCustomPOIGroup(owner)
  }

  public canAdminEditPlan(plan: Plan.Plan): boolean {
    return this.permissionResolver.canAdminEditPlan(plan)
  }

  public canShowWidgetUploadAssets(): boolean {
    return this.permissionResolver.canShowWidgetUploadAssets()
  }

  public canShowStats(meta: Metadata.AppMetadata): boolean {
    return this.permissionResolver.canShowStats(meta)
  }

  public canAccessCustomizationByCountry(
    metadata: Metadata.AppMetadata,
    environment: Environment.EnvironmentResolver,
  ): boolean {
    return this.permissionResolver.canAccessCustomizationByCountry(
      metadata,
      environment,
    )
  }

  public canChangePlanOwner(plan: Plan.Plan): boolean {
    return this.permissionResolver.canChangePlanOwner(plan)
  }

  public canSeeAllPlans(): boolean {
    return this.permissionResolver.canSeeAllPlans()
  }
}

export default UserPermissionManager
